<template>
  <div
    class="w-full h-full flex flex-col items-center justify-center animate-fade-in"
    :class="[theme.text, isWatch ? 'p-2' : 'p-6']"
  >
    <div class="w-full" :class="isWatch ? 'max-w-full' : 'max-w-sm'">
      <div class="text-center mb-6">
        <div class="font-bold mb-2" :class="isWatch ? 'text-xl' : 'text-3xl'">
          {{ t.login_title }}
        </div>
        <div class="opacity-50" :class="isWatch ? 'text-[10px]' : 'text-sm'">
          {{ t.login_desc }}
        </div>
      </div>
      <div class="space-y-3 mb-4">
        <div
          class="flex items-center rounded-2xl border transition-all"
          :class="[
            theme.isDark
              ? 'bg-white/5 border-white/10'
              : 'bg-white/50 border-black/5',
            isWatch ? 'p-2' : 'p-4',
          ]"
        >
          <icon-base
            name="Smartphone"
            class="opacity-50 mr-3"
            :class="isWatch ? 'w-4 h-4' : 'w-5 h-5'"
          ></icon-base>
          <input
            v-model="loginForm.phone"
            type="tel"
            :placeholder="t.phone_placeholder"
            class="bg-transparent outline-none flex-1 font-medium"
            :class="isWatch ? 'text-sm' : ''"
          />
        </div>
        <div
          class="flex items-center rounded-2xl border transition-all"
          :class="[
            theme.isDark
              ? 'bg-white/5 border-white/10'
              : 'bg-white/50 border-black/5',
            isWatch ? 'p-2' : 'p-4',
          ]"
        >
          <icon-base
            name="Key"
            class="opacity-50 mr-3"
            :class="isWatch ? 'w-4 h-4' : 'w-5 h-5'"
          ></icon-base>
          <input
            v-model="loginForm.code"
            type="number"
            :placeholder="t.code_placeholder"
            class="bg-transparent outline-none flex-1 font-medium"
            :class="isWatch ? 'text-sm' : ''"
          />
          <button
            @click="handleSendSms"
            :disabled="smsCooldown > 0"
            class="text-xs font-bold px-3 py-1.5 rounded-lg whitespace-nowrap transition-colors"
            :class="
              theme.isDark
                ? 'bg-white/10 hover:bg-white/20'
                : 'bg-black/5 hover:bg-black/10'
            "
          >
            {{ smsCooldown > 0 ? `${smsCooldown}s` : t.get_code }}
          </button>
        </div>
      </div>
      <button
        @click="handleLogin"
        class="w-full rounded-2xl font-bold shadow-xl transition-all active:scale-95 flex items-center justify-center"
        :class="[theme.accent, isWatch ? 'py-3 text-sm' : 'py-4 text-lg']"
        :disabled="loading"
      >
        <icon-base
          v-if="loading"
          name="Refresh"
          class="w-5 h-5 animate-spin"
        ></icon-base>
        <span v-else>{{ t.login_btn }}</span>
      </button>
      <button
        @click="$emit('back')"
        class="w-full py-3 text-xs font-medium opacity-50 hover:opacity-100 mt-1"
      >
        {{ t.skip_login }}
      </button>
    </div>
  </div>
</template>

<script>
import { sendSms, phoneLogin } from "@/api"; // 引入 API

export default {
  props: ["theme", "t", "device"],
  data() {
    return {
      loading: false,
      loginForm: {
        phone: "",
        code: "",
      },
      smsCooldown: 0,
      timer: null,
    };
  },
  computed: {
    isWatch() {
      return this.device === "WATCH";
    },
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
  methods: {
    // 发送验证码 [cite: 2]
    async handleSendSms() {
      if (!this.loginForm.phone) return alert("请输入手机号");
      if (this.smsCooldown > 0) return;

      try {
        await sendSms(this.loginForm.phone);
        // 开始倒计时
        this.smsCooldown = 60;
        this.timer = setInterval(() => {
          this.smsCooldown--;
          if (this.smsCooldown <= 0) clearInterval(this.timer);
        }, 1000);
        // 实际项目中可以添加 Toast 提示 "发送成功"
      } catch (error) {
        alert(error.message || "验证码发送失败");
      }
    },
    // 登录 [cite: 20]
    async handleLogin() {
      if (!this.loginForm.phone || !this.loginForm.code) return;

      this.loading = true;
      try {
        const data = await phoneLogin({
          phone: this.loginForm.phone,
          smsCode: this.loginForm.code, // 注意字段名需与 API 文档一致 [cite: 30]
        });

        // 存储 Token [cite: 34]
        if (data.token) {
          localStorage.setItem("zeno_token", data.token);
          this.$emit("login", data);
        } else {
          throw new Error("Token missing");
        }
      } catch (error) {
        alert(error.message || "登录失败");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
